import zhCN from 'date-fns/esm/locale/zh-CN/index';
import moment from 'moment-timezone';
import dayjs from 'dayjs';

class CentralCalls {
  static formatDateToEastern(utcDate) {
    return moment(utcDate).tz('America/New_York').format('MM/DD/YYYY h:mm A');
  }
  static async upsertData(jsonObj, tableName, upsertType) {
    try {
      const response = await fetch('/api/upsert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tableName, jsonObj, changeType: upsertType }),
      });
      const data = await response.json();
      if (data.error) {
        alert('Error updating data.Check duplicate Lot Number OR reach out for assistance')
      }
      return data.result; // Return the response data if needed
    } catch (err) {
      alert('Error updating data.Check duplicate Lot Number OR reach out for assistance')
      console.error(err);
      // Handle error
    }
  }
  static async fetchTableData(tableName, whereClause) {
    //whereClause = JSON.stringify(whereClause)

    try {
      const response = await fetch('/api/table_select', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tableName, whereClause }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch table data.');
      }
      const data  = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw new Error('An error occurred while fetching table data.');
    }
  }
  static async tableSelect(tableName, whereClause) {
    return CentralCalls.fetchTableData(tableName, whereClause);
  }
  static async fetchTableDataNoWhere(tableName) {

    try {
      const response = await fetch('/api/table_select', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tableName }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch table data.');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      throw new Error('An error occurred while fetching table data.');
    }
  }
  static async callStoredProcedureWithParams(procedureName, param) {
    const requestData = {
      procedureName,
      param
    };
    try {
      const response = await fetch('/api/call-stored-procedureWithParam3', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ procedureName, param: JSON.stringify(param) }),
      });
     
      if (!response.ok) {
        throw new Error('Failed to query the database');
      }
      const result = await response.json();

      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  // Inside the CentralCalls class
  static async exportDataToExcel(startDate, endDate) {
    try {
      const response = await fetch('/api/export', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ startDate: startDate, endDate: endDate }),
      });
      if (!response.ok) {
        throw new Error('Failed to export data.');
      }
      const blob = await response.blob();
      // Create a link to trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'data.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (error) {
      console.error(error);
      throw new Error('An error occurred while exporting data.');
    }
  }

  static async callStoredProcedureNoParams(procedureName) {
    const requestData = {
      procedureName
    };

    try {
      const response = await fetch('/api/call-stored-procedure', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ procedureName }),
      });

      if (!response.ok) {
        throw new Error('Failed to query the database');
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  static formatDate(dateString, format) {
    
    if (format && dateString && dateString !== '' && format === 'noyear') {
      try {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}`;
      } catch {
        console.log('ERROR! Parsing date');
        return dateString;
      }
    } else if (format && dateString && dateString !== '' && format === 'short') {
      try {
        const [year, month, day] = dateString.split('-');
        const lastTwoDigitsOfYear = year.slice(-2);
        return `${month}/${day}/${lastTwoDigitsOfYear}`;
      } catch {
        console.log('ERROR! Parsing date');
        console.log(dateString);
        console.log(format);
        return dateString;
      }
    } else {
      return dateString;
    }
  };
  static formatTotal(total) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(total);
  }
  static sqlFormatdatetime() {
    const date = new Date(); // Get the current date and time
    
    // Get components of the date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    const day = String(date.getDate()).padStart(2, '0');
  
    // Get components of the time
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    // Construct the SQL datetime format
    const mysqlDatetimeFormat = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  
    return mysqlDatetimeFormat;
  }
  static sqlFormatDate2(dateString){
    return dateString ? dayjs(dateString).format('YYYY-MM-DD') : null;
  }
  static normalizeDateOnly(value) {
    if (!value) return null;

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return null;

      // DATE column values should already be YYYY-MM-DD; preserve them as-is.
      const dateOnlyMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})$/);
      if (dateOnlyMatch) {
        return dateOnlyMatch[1];
      }

      // If a time portion exists, safely keep only the date portion.
      const dateTimeMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})[T\s]/);
      if (dateTimeMatch) {
        return dateTimeMatch[1];
      }

      const parsed = new Date(trimmed);
      if (Number.isNaN(parsed.getTime())) {
        return null;
      }

      return parsed.toISOString().split('T')[0];
    }

    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) {
        return null;
      }
      return value.toISOString().split('T')[0];
    }

    return null;
  }
  static sqlFormatdate(dateString) {
    return CentralCalls.normalizeDateOnly(dateString);
  }
}

export default CentralCalls;